import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const [authStatus, setAuthStatus] = useState(null); // Initialize to null

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  useEffect(() => {
    const teamID = getCookie("teamID");
    const authToken = getCookie("authToken");

    if (teamID && authToken) {
      setAuthStatus(true);
    } else {
      setAuthStatus(false);
    }
  }, []);

  if (authStatus === null) {
    // Render nothing or a loading state while checking cookies
    return null;
  }

  if (!authStatus) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
